import type { RouteRecordRaw } from 'vue-router'
import { AppModule } from '@/config/types'
import type { ComponentProps } from '@/composition/types'
import type GettingStarted from '@/components/views/gettingStarted/GettingStarted.vue'
import type { Route } from '@/services/route/types'
import { gettingStartedRoutName } from '@/routes/user/getting-started/types'

export const getGettingStartedRoutes = (): RouteRecordRaw[] => [
  {
    name: gettingStartedRoutName,
    path: 'getting-started',
    props: (route: Route) => {
      let initSection: string | undefined
      if (typeof route.query.tab === 'string') {
        initSection = route.query.tab
      }
      return {
        initSection,
      } satisfies ComponentProps<typeof GettingStarted>
    },
    meta: {
      tags: ['USER_TOP_MENU'],
      tabTitle: 'pageTabTitle.user.gettingStarted',
      accessControlGroups: ['GettingStartedStrategy'],
      modules: [
        AppModule.TenDlcTollFreeRequest,
        AppModule.ByocHelper,
        AppModule.Byoc,
        AppModule.StripeBilling,
        AppModule.Compose,
        AppModule.WhatsApp,
        AppModule.Instagram,
        AppModule.Facebook,
        AppModule.CampaignsSenders,
      ],
      resolvers: [
        {
          service: 'EmailCampaignDomainsResolverService',
        },
        {
          service: 'GettingStartedInfoResolverService',
        },
      ],
    },
    component: () => import('@/components/views/gettingStarted/GettingStarted.vue'),
  },
]
